import { getTwitterUsername, getSocialLink } from "./socialUtils";

export { getTwitterUsername, getSocialLink };
